import {useMutation} from "@tanstack/react-query";

import {editLeadNoteMutationOptions} from "./edit-lead-note.mutation-options";

export function useEditLeadNote(leadId: string, noteId: number) {
  return useMutation(editLeadNoteMutationOptions(leadId, noteId));
}
